export default "__VITE_ASSET__B41UEOJG__"